import { BellElectric, BotMessageSquare, CheckCheck, CornerDownRight, LayoutGrid, ListChecks, Minus, Pencil, Plus } from "lucide-react";
import React, { useEffect, useState } from "react";
import fallback_img from "../img/fallback_img.jpg"
import loading_img from "../img/loadingImg.jpg"
import ScrollTransformWrapper from "../../../DesignElements/hook/ScrollTransformWrapper";

const   PlatformKeyFeaturesCard1 = ({ setCurrentContentIndex,currentIndex,CurrentObject ,setCurrentObject, setHideReduUnDo, moveItemUp,moveItemDown,deleteItem,duplicateItem,duplicateContentsItem,item ,dynamicId,
    
}) =>{


 const [relativeTop, setRelativeTop] = useState(0);
 const [scrollProgress, setScrollProgress] = useState(0);
 const [isVisible, setIsVisible] = useState(true);
 
               let  myStyles=   {
 circleL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"50%",width:relativeTop? ` ${(scrollProgress*4 )}px `:'',height:relativeTop? ` ${(scrollProgress*4 )}px `:''},
 circleR:{ position:"absolute",left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"50%",width:relativeTop? ` ${(scrollProgress*4 )}px `:'',height:relativeTop? ` ${(scrollProgress*4 )}px `:''},
 squareL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*2 )}px `:'',height:relativeTop? ` ${(scrollProgress*2 )}px `:''},
 squareR:{ position:"absolute",left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*2 )}px `:'',height:relativeTop? ` ${(scrollProgress*2 )}px `:''},
 rectangleHR:{ position:"absolute", left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rhombusHR:{ position:"absolute", left:relativeTop? ` ${(scrollProgress*2 )}px `:"",transform:"skewX(40deg)",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rectangleHL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*3 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rhombusHL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*3 )}px `:"",transform:"skewX(40deg)",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
       
          goUp:{transform:relativeTop? ` translateY(${(relativeTop*3 )}px) `:''},
         goDown:{transform:relativeTop? ` translateY(${(-relativeTop*3 )}px) `:''},
         goLeft:{transform:relativeTop>0? ` translateX(${(relativeTop*3 )}px) `:''},
         goRight:{transform:relativeTop>0? ` translateX(${(-relativeTop*3 )}px) `:''},
        
         zoomIn:{transform:relativeTop? `  scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
        zoomOut:{transform:relativeTop? `  scale(${(relativeTop>1?(relativeTop/100)*1:1 )}) `:''},
       
         skewVertical:{transform:relativeTop>0? ` rotateX(${(relativeTop<90&&relativeTop>0?relativeTop:0  )}deg) skewX(${(relativeTop<30&&relativeTop>0?relativeTop:0 )}deg) `:''},
         skewHorizontal:{transform:relativeTop>0? ` rotateY(${(relativeTop<90&&relativeTop>0?relativeTop:0  )}deg) skewY(${(relativeTop<30&&relativeTop>0?relativeTop:0 )}deg) `:''},
          
         flipVertical:{transform:relativeTop>0? `   rotateX(${(relativeTop<60?-relativeTop:0)}deg) `:''},
          flipHorizontal:{transform:relativeTop>0? `   rotateY(${(relativeTop<60?-relativeTop:0)}deg) `:''},
        spinLeft:{transform:relativeTop>0? `  rotateZ(${(relativeTop )}deg) `:''},
        spinRight:{transform:relativeTop>0? `  rotateZ(${(-relativeTop )}deg) `:''},
       
         slideUpZoom:{transform:relativeTop? ` translateY(${((relativeTop)*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideDownZoom:{transform:relativeTop? ` translateY(${((-relativeTop) )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideLeftZoom:{transform:relativeTop>0? ` translateX(${(relativeTop*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideRightZoom:{transform:relativeTop>0? ` translateX(${(-relativeTop*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         
         slideUpSkew:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  skewX(${((relativeTop<60?relativeTop:0) )}deg) `:''},
        slideDownSkew:{transform:relativeTop>0? `  translateY(${(-relativeTop*3 )}px)  skewX(${((relativeTop<60?-relativeTop:0) )}deg) `:''},
        slideLeftSkew:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  skewX(${((relativeTop<60?-relativeTop:0) )}deg) `:''},
        slideRightSkew:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  skewX(${((relativeTop<60?relativeTop:0) )}deg) `:''},
        
        slideUpRotate:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateZ(${(relativeTop )}deg) `:''},
        slideDownRotate:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateZ(${(-relativeTop )}deg) `:''},
        slideLeftRotate:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  rotateZ(${((-relativeTop) )}deg) `:''},
        slideRightRotate:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  rotateZ(${(relativeTop )}deg) `:''},
       
        slideUpFlip:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateY(${(relativeTop )}deg) `:''},
        slideDownFlip:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateY(${(-relativeTop )}deg) `:''},
        slideLeftFlip:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  rotateY(${((-relativeTop) )}deg) `:''},
        slideRightFlip:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  rotateY(${(relativeTop )}deg) `:''},
       
  
          
        }






 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }
       const fonts=[
  {name:"AlumniSansSC-Regular",
  fontFamily:"AlumniSansSCRegular , 'Helvetica Neue',sans-serif"
 }
 ,{name:"AlumniSansSC-Italic",
  fontFamily:"AlumniSansSCItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Regular",
  fontFamily:"InterRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Italic",
  fontFamily:"InterItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Lato-Light",
  fontFamily:"LatoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Montserrat-Light",
  fontFamily:"MontserratLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Poppins-Regular",
  fontFamily:"PoppinsRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Light",
  fontFamily:"RalewayLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Thin",
  fontFamily:"RalewayThin , 'Helvetica Neue',sans-serif"
 }

];
  const imagesList1 = [
                   { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                 { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized ScheduleJoin Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1664541336896-b3d5f7dec9a3?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                             { id: 5,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 6,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                ];
                 const imagesList2 = [
                   { id: 1,hideImage: false, title: "1x1",subtitle: "Live Online Sessions", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                 { id: 2,hideImage: false, title: "Personalised",subtitle: "Result-Oriented Curriculum", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 3,hideImage: false, title: "Performance",subtitle: "Opportunities to perform live", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 4,hideImage: false, title: "Graded Syllabus",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 5,hideImage: false, title: "Graded Syllabus",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"  },
                            ];
                const titleList1 = [
                   { id: 1,hideImage: false, title: "Only at ClasssMock!",subtitle: "Learn music & dance at your own pace through a personalized adaptive learning model that favors your interest and growth. Get a trusted result-oriented curriculum created by industry experts to accelerate your learning. You will also get multiple performance opportunities to boost your confidence and improve your technical skills.", image: "none" },
                       ];
  const  [cardObjectInn ,setCardObject] =useState(CurrentObject);
  
   const [isHovered, setIsHovered] = useState(false);
const ImageFallFB = ({ boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div  style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
    width:`${width}px`}}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width-10}px`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width-10}px`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}px`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
      />
    </div>
  );
};
return(<>
{}
  <ScrollTransformWrapper 
  setRelativeTop={(relativeTop)=>{setRelativeTop(relativeTop)}}
  setIsVisible={(isVisible)=>{setIsVisible(isVisible)}}
  setScrollProgress={(scrollProgress)=>{setScrollProgress(scrollProgress)}}
  containerId="scrollContainerId"
        maxTranslate={100}
        maxRotate={0}
        maxScale={1.1}
        customStyleFn={({ scale }) => ({
          myStyles:myStyles,
          transition: "transform 0.2s ease-in-out",
        })}
      >
        
      
<div   className="hoverItemElementInner" onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)} 
      style={{
position:"relative",border:dynamicId==CurrentObject?.myKey?"2px solid rgba(144, 202, 249,1)":isHovered?"2px solid rgba(144, 202, 249,1)":"2px solid transparent",
          borderRadius:"10px",margin:"5px",marginTop:"25px",overflow:"hidden"}} >{}
           <div  style={{ ...myStyles[!CurrentObject?.contents[0]?.layoutSettings?.disableAnimation?CurrentObject?.contents[0]?.layoutSettings?.shape1Animation?.type:""],
            background:CurrentObject?.contents[0]?.layoutSettings?.shape1Animation?.color?.color,
           

  transition: `transform 0.2s ease-in-out, opacity 0.5s ease`,}}></div>
     <div  style={{ ...myStyles[!CurrentObject?.contents[0]?.layoutSettings?.disableAnimation?CurrentObject?.contents[0]?.layoutSettings?.shape2Animation?.type:""],
            background:CurrentObject?.contents[0]?.layoutSettings?.shape2Animation?.color?.color,
            top:"110px",

  transition: `transform 0.2s ease-in-out, opacity 0.5s ease`,}}></div>
     
                    <div className={isHovered?"":""} onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}  style={{height:"30px",width:"100%",position:"absolute",top:"-5px",left:"0px",}}>
       {dynamicId==CurrentObject?.contents[0]?.myKey? <div   style={{position:"absolute",top:"-12px",left:"0px",fontSize:"12px",width:"73px",height:"25px",borderRadius:"5px"}}> <div style={{position:"absolute",top:"0px",left:"0px",right:"0px",bottom:"0px"}}><div className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",position:"absolute",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"60px",height:"15px",paddingRight:"5px",}}> <CheckCheck size={12}  color="#333" /> Selected</div></div></div>:
        
          ""}  
    
       
        {isHovered? <div onClick={()=>{setCurrentObject(CurrentObject?.contents[0]?.myKey,CurrentObject?.contents[0]);setCurrentContentIndex(CurrentObject?.contents[0]?.contentNo)}} className={isHovered?"":""}
            style={{position:"absolute",top:"-9px",width:"27px",height:"28px",}}> <div style={{position:"absolute",top:"1px",left:"0px",right:"0px",bottom:"0px"}}> <div className="ElementSettingsItem"   style={{display:"flex",justifyContent:"space-between",position:"absolute",fontSize:"12px",padding:"3px",left:"-1px"}}> <Pencil size={18}  color="#333" /></div></div> </div>:""}
    </div>
      <div className={`PlatformKeyFeaturesCard1-card-${CurrentObject?.contents[0]?.myKey}`}>
      
        
      
      
       {CurrentObject?.contents.map((itemOuter,indexOuter)=>(<>
       {indexOuter==2?<> <div className={`PlatformKeyFeaturesCard1-cardRight-${itemOuter?.myKey}`} 
          onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo)); }}
         style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.layoutAnimation?.type:""],
  transition: `transform 0.${indexOuter * 5}s ease-in-out, opacity 0.5s ease`,
}} > {}
      {/* {itemOuter?.layoutSettings?.layoutBG?.color1} */}
       {itemOuter?.itemCards?.cards.map((itemInner,indexInner)=>(< >
       
        <div className={`PlatformKeyFeaturesCard1-cardRight-item-wrapper${itemOuter?.myKey}`} style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item5Animation?.type:""],
  transition: `transform 0.${indexInner * 2}s ease-in-out, opacity 0.5s ease`,
}}> 
        <div className={`PlatformKeyFeaturesCard1-cardRight-item-wrapperInner${itemOuter?.myKey}`}>
        <div className={`PlatformKeyFeaturesCard1-cardRight-text-wrapper${itemOuter?.myKey}`}
        style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item6Animation?.type:""],
  transition: `transform 0.${indexInner * 2}s ease-in-out, opacity 0.5s ease`,
}}>
          <h4 className={`PlatformKeyFeaturesCard1-cardRight-title-${itemOuter?.myKey}  ${itemOuter?.layoutSettings?.titleEllipsis?.status?`PlatformKeyFeaturesCard1-cardRight-title-ellipsis-${itemOuter?.myKey}`:``}`} 
          
          style={{ ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item1Animation?.type:""],
  transition: `transform 0.${indexInner * 5}s ease-in-out, opacity 0.5s ease`,
    fontSize: `${itemOuter?.layoutSettings?.typographyTitle?.size?.value}${itemOuter?.layoutSettings?.typographyTitle?.size?.resolution}`,
    fontFamily: `${itemOuter?.layoutSettings?.typographyTitle?.family?.fontFamily}`,
    fontWeight: `${itemOuter?.layoutSettings?.typographyTitle?.weight?.fontWeight}`,
    textAlign: `${itemOuter?.layoutSettings?.typographyTitle?.textAlignment?.textAlign}`,
    textTransform: `${itemOuter?.layoutSettings?.typographyTitle?.textCase?.textTransform}`,
    fontStyle: `${itemOuter?.layoutSettings?.typographyTitle?.textStyle?.textStyle}`,
   textDecoration: `${itemOuter?.layoutSettings?.typographyTitle?.decoration?.line}  ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.style} ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.decorationColor?.color} ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.thickness?.value}${itemOuter?.layoutSettings?.typographyTitle?.decoration?.thickness?.resolution}`,
      lineHeight: `${itemOuter?.layoutSettings?.typographyTitle?.lineHeight?.value}${itemOuter?.layoutSettings?.typographyTitle?.lineHeight?.resolution}`,
    letterSpacing: "1px",
    wordSpacing: "10px",
    WebkitTextStroke: "1px rgba(38, 36, 36, 1)",
    textShadow: "10px 10px 10px 10px rgba(221, 253, 253, 0.93)",
  
     }}
          
          >{!itemInner?.hideTitle?itemInner?.title:""}</h4>
          <p className={`PlatformKeyFeaturesCard1-cardRight-description-${itemOuter?.myKey} 
            ${itemOuter?.layoutSettings.subtitleEllipsis?.status?`PlatformKeyFeaturesCard1-cardRight-description-ellipsis-${itemOuter?.myKey}`:``}`}
              style={{ ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item2Animation?.type:""],
  transition: `transform 0.${indexInner * 5}s ease-in-out, opacity 0.5s ease`,
    fontSize: `${itemOuter?.layoutSettings?.typographySubtitle?.size?.value}${itemOuter?.layoutSettings?.typographySubtitle?.size?.resolution}`,
    fontFamily: `${itemOuter?.layoutSettings?.typographySubtitle?.family?.fontFamily}`,
    fontWeight: `${itemOuter?.layoutSettings?.typographySubtitle?.weight?.fontWeight}`,
    textAlign: `${itemOuter?.layoutSettings?.typographySubtitle?.textAlignment?.textAlign}`,
    textTransform:`${itemOuter?.layoutSettings?.typographySubtitle?.textCase?.textTransform}`,
    fontStyle: `${itemOuter?.layoutSettings?.typographySubtitle?.textStyle?.textStyle}`,
    textDecoration: `${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.line}  ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.style} ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.decorationColor?.color} ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.thickness?.value}${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.thickness?.resolution}`,
    lineHeight: ` ${itemOuter?.layoutSettings?.typographySubtitle?.lineHeight?.value}${itemOuter?.layoutSettings?.typographySubtitle?.lineHeight?.resolution}`,
    letterSpacing: "1px",
    wordSpacing: "10px",
    WebkitTextStroke: "1px rgba(38, 36, 36, 1)",
    textShadow: "10px 10px 10px 10px rgba(221, 253, 253, 0.93)",
  
     }}>
           {!itemInner?.hideSubtitle? itemInner?.subtitle:""}</p>
         </div> <div className={`PlatformKeyFeaturesCard1-CardSVGBG-wrapper${itemOuter?.myKey}`} 
         style={itemOuter?.layoutSettings?.mirrorItems?.status?indexInner%2==0?{
          ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item4Animation?.type:""],
  transition: `transform 0.${indexInner * 5}s ease-in-out`,borderRadius:`${itemOuter?.layoutSettings?.borderRadius3?.value}${itemOuter?.layoutSettings?.borderRadius3?.resolution}`,
border:`${itemOuter?.layoutSettings?.item2Border?.borderWidth?.value}px ${itemOuter?.layoutSettings?.item2Border?.borderType} ${itemOuter?.layoutSettings?.item2Border?.borderColor?.color}`,
background:`${itemOuter?.layoutSettings?.item2BG?.color}`,
        bottom:`${itemOuter?.layoutSettings?.marginItem1?.marginBottom?.value}${itemOuter?.layoutSettings?.marginItem1?.marginBottom?.resolution}`,
            left:`${itemOuter?.layoutSettings?.marginItem1?.marginLeft?.value}${itemOuter?.layoutSettings?.marginItem1?.marginLeft?.resolution}`,
            paddingTop:`${itemOuter?.layoutSettings?.paddingItem1?.paddingTop?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingTop?.resolution}`,
            paddingBottom:`${itemOuter?.layoutSettings?.paddingItem1?.paddingBottom?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingBottom?.resolution}`,
            paddingLeft:`${itemOuter?.layoutSettings?.paddingItem1?.paddingLeft?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingLeft?.resolution}`,
            paddingRight:`${itemOuter?.layoutSettings?.paddingItem1?.paddingRight?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingRight?.resolution}`
    }:{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item4Animation?.type:""],
  transition: `transform 0.${indexInner * 5}s ease-in-out`,borderRadius:`${itemOuter?.layoutSettings?.borderRadius3?.value}${itemOuter?.layoutSettings?.borderRadius3?.resolution}`,
border:`${itemOuter?.layoutSettings?.item2Border?.borderWidth?.value}px ${itemOuter?.layoutSettings?.item2Border?.borderType} ${itemOuter?.layoutSettings?.item2Border?.borderColor?.color}`,
background:`${itemOuter?.layoutSettings?.item2BG?.color}`,
        bottom:`${itemOuter?.layoutSettings?.marginItem1?.marginBottom?.value}${itemOuter?.layoutSettings?.marginItem1?.marginBottom?.resolution}`,
            right:`${itemOuter?.layoutSettings?.marginItem1?.marginLeft?.value}${itemOuter?.layoutSettings?.marginItem1?.marginLeft?.resolution}`,
            paddingTop:`${itemOuter?.layoutSettings?.paddingItem1?.paddingTop?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingTop?.resolution}`,
            paddingBottom:`${itemOuter?.layoutSettings?.paddingItem1?.paddingBottom?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingBottom?.resolution}`,
            paddingLeft:`${itemOuter?.layoutSettings?.paddingItem1?.paddingLeft?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingLeft?.resolution}`,
            paddingRight:`${itemOuter?.layoutSettings?.paddingItem1?.paddingRight?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingRight?.resolution}`
    }:{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item4Animation?.type:""],
  transition: `transform 0.${indexInner * 5}s ease-in-out`,borderRadius:`${itemOuter?.layoutSettings?.borderRadius3?.value}${itemOuter?.layoutSettings?.borderRadius3?.resolution}`,
border:`${itemOuter?.layoutSettings?.item2Border?.borderWidth?.value}px ${itemOuter?.layoutSettings?.item2Border?.borderType} ${itemOuter?.layoutSettings?.item2Border?.borderColor?.color}`,
background:`${itemOuter?.layoutSettings?.item2BG?.color}`,
         bottom:`${itemOuter?.layoutSettings?.marginItem1?.marginBottom?.value}${itemOuter?.layoutSettings?.marginItem1?.marginBottom?.resolution}`,
           right:`${itemOuter?.layoutSettings?.marginItem1?.marginLeft?.value}${itemOuter?.layoutSettings?.marginItem1?.marginLeft?.resolution}`,
            paddingTop:`${itemOuter?.layoutSettings?.paddingItem1?.paddingTop?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingTop?.resolution}`,
            paddingBottom:`${itemOuter?.layoutSettings?.paddingItem1?.paddingBottom?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingBottom?.resolution}`,
            paddingLeft:`${itemOuter?.layoutSettings?.paddingItem1?.paddingLeft?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingLeft?.resolution}`,
            paddingRight:`${itemOuter?.layoutSettings?.paddingItem1?.paddingRight?.value}${itemOuter?.layoutSettings?.paddingItem1?.paddingRight?.resolution}`
    }}></div>
         
        </div><div className={`PlatformKeyFeaturesCard1-CardImage-wrapper${itemOuter?.myKey}`}
        style={itemOuter?.layoutSettings?.mirrorItems?.status?indexInner%2==0?{
          marginTop:"-100px",...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item3Animation?.type:""],
  transition: `transform 0.${indexInner * 5}s ease-in-out, opacity 0.5s ease`,
               top:`${itemOuter?.layoutSettings?.marginItem1?.marginTop?.value*2}${itemOuter?.layoutSettings?.marginItem1?.marginTop?.resolution}`,
                   right:`${itemOuter?.layoutSettings?.marginItem1?.marginRight?.value}${itemOuter?.layoutSettings?.marginItem1?.marginRight?.resolution}`,
  
borderRadius:`${itemOuter?.layoutSettings?.borderRadius2?.value}${itemOuter?.layoutSettings?.borderRadius2?.resolution}`,

   paddingTop:`${itemOuter?.layoutSettings?.paddingItem2?.paddingTop?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingTop?.resolution}`,
            paddingBottom:`${itemOuter?.layoutSettings?.paddingItem2?.paddingBottom?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingBottom?.resolution}`,
            paddingLeft:`${itemOuter?.layoutSettings?.paddingItem2?.paddingLeft?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingLeft?.resolution}`,
            paddingRight:`${itemOuter?.layoutSettings?.paddingItem2?.paddingRight?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingRight?.resolution}`
 }:{  marginTop:"-100px",...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item3Animation?.type:""],
  transition: `transform 0.${indexInner * 5}s ease-in-out, opacity 0.5s ease`,
    top:`${itemOuter?.layoutSettings?.marginItem1?.marginTop?.value*2}${itemOuter?.layoutSettings?.marginItem1?.marginTop?.resolution}`,
                              left:`${itemOuter?.layoutSettings?.marginItem1?.marginRight?.value}${itemOuter?.layoutSettings?.marginItem1?.marginRight?.resolution}`,
  
borderRadius:`${itemOuter?.layoutSettings?.borderRadius2?.value}${itemOuter?.layoutSettings?.borderRadius2?.resolution}`,

   paddingTop:`${itemOuter?.layoutSettings?.paddingItem2?.paddingTop?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingTop?.resolution}`,
            paddingBottom:`${itemOuter?.layoutSettings?.paddingItem2?.paddingBottom?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingBottom?.resolution}`,
            paddingLeft:`${itemOuter?.layoutSettings?.paddingItem2?.paddingLeft?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingLeft?.resolution}`,
            paddingRight:`${itemOuter?.layoutSettings?.paddingItem2?.paddingRight?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingRight?.resolution}`
 }:{   marginTop:"-100px",...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item3Animation?.type:""],
  transition: `transform 0.${indexInner * 5}s ease-in-out, opacity 0.5s ease`,
   top:`${itemOuter?.layoutSettings?.marginItem1?.marginTop?.value*2}${itemOuter?.layoutSettings?.marginItem1?.marginTop?.resolution}`,
                           left:`${itemOuter?.layoutSettings?.marginItem1?.marginRight?.value}${itemOuter?.layoutSettings?.marginItem1?.marginRight?.resolution}`,
  
borderRadius:`${itemOuter?.layoutSettings?.borderRadius2?.value}${itemOuter?.layoutSettings?.borderRadius2?.resolution}`,

   paddingTop:`${itemOuter?.layoutSettings?.paddingItem2?.paddingTop?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingTop?.resolution}`,
            paddingBottom:`${itemOuter?.layoutSettings?.paddingItem2?.paddingBottom?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingBottom?.resolution}`,
            paddingLeft:`${itemOuter?.layoutSettings?.paddingItem2?.paddingLeft?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingLeft?.resolution}`,
            paddingRight:`${itemOuter?.layoutSettings?.paddingItem2?.paddingRight?.value}${itemOuter?.layoutSettings?.paddingItem2?.paddingRight?.resolution}`
 }}
        
        > {!itemInner?.hideImage?<ImageFallFB  boxShadow={`${itemOuter?.layoutSettings?.item1Shadow?.horizontal?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.vertical?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.blur?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.spread?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.shadowColor?.color} ${itemOuter?.layoutSettings?.item1Shadow?.inset?"inset":""}`} src={itemInner.image} border={`${itemOuter?.layoutSettings?.item1Border?.borderWidth?.value}px ${itemOuter?.layoutSettings?.item1Border?.borderType} ${itemOuter?.layoutSettings?.item1Border?.borderColor?.color}`} width={itemOuter?.layoutSettings.item1Width?.value?itemOuter?.layoutSettings.item1Width?.value:70} aspectRatio={itemOuter?.layoutSettings.item1AspectRatio?.value?itemOuter?.layoutSettings.item1AspectRatio?.value:1} borderRadius={itemOuter?.layoutSettings?.borderRadius2?itemOuter?.layoutSettings?.borderRadius2:{value:30,resolution:"%"}} /> :""}
         </div></div></>))}   </div></>:""}</>))}
         {CurrentObject?.contents.map((itemOuter,indexOuter)=>(<>
      
       {indexOuter==1?<>
       {/* Key: {itemOuter?.myKey}
                             Width:  {itemOuter?.layoutSettings?.layoutWidth?.value}{itemOuter?.layoutSettings?.layoutWidth?.resolution} 
                               Height:  {itemOuter?.layoutSettings?.layoutHeight?.value}{itemOuter?.layoutSettings?.layoutHeight?.resolution} 
                      Direction:  {itemOuter?.layoutSettings?.flexDirection}
                       Justify Content:  {itemOuter?.layoutSettings?.justifyContent}
                         alignItems:  {itemOuter?.layoutSettings?.alignItems}
                          alignContent:  {itemOuter?.layoutSettings?.alignContent}
                      gap:  {itemOuter?.layoutSettings?.gap}
                      flexWrap:  {itemOuter?.layoutSettings?.flexWrap} */}
        <div className={`PlatformKeyFeaturesCard1-cardLeft-${itemOuter?.myKey}`} style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.layoutAnimation?.type:""],
  transition: `transform 0.1s ease-in-out, opacity 0.5s ease`,
}}>
      
       {itemOuter?.itemCards?.cards.map((itemInner,indexInner)=>(<>
         <div className={`PlatformKeyFeaturesCard1-cardLeft-text-wrapper${itemOuter?.myKey}`} 
          onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo)); }}
          >
          <div className={`PlatformKeyFeaturesCard1-title-${itemOuter?.myKey}`} style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item1Animation?.type:""],
  transition: `transform 0.${indexInner * 2}s ease-in-out, opacity 0.5s ease`,
}}>{itemInner?.title}</div>
          <p className={`PlatformKeyFeaturesCard1-description-${itemOuter?.myKey}`} style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item2Animation?.type:""],
  transition: `transform 0.${indexInner * 5}s ease-in-out, opacity 0.5s ease`,
}}>{itemInner?.subtitle}</p>
        </div></>))}
        
        </div></>:""}</>))}
        
     
     
      </div> </div></ScrollTransformWrapper>
      {/* <div className={`PlatformKeyFeaturesCard1-cardBottom${CurrentObject?.contents[2]?.myKey}`}>
       
 {CurrentObject?.contents.map((itemOuter,indexOuter)=>(<>
       {indexOuter==2?<>
       {itemOuter?.itemCards?.cards.map((itemInner,indexInner)=>(<>
        <div className={`PlatformKeyFeaturesCard1-cardBottom-item-wrapper${CurrentObject?.contents[2]?.myKey}`}>
         <h4 className={`PlatformKeyFeaturesCard1-title-${CurrentObject?.contents[2]?.myKey}`}>{itemInner?.title}</h4>
          <p className={`PlatformKeyFeaturesCard1-description-${CurrentObject?.contents[2]?.myKey}`}>{itemInner?.subtitle}</p>
        
       </div> </>))}</>:""}</>))} </div> */}
      {/* Inline styles inside the component */}
      <style>{ CurrentObject?.contents?.map((item,index)=>(`
        .PlatformKeyFeaturesCard1-card-${item?.myKey} {
          display: ${"flex"};
           width:${item?.layoutSettings?.layoutWidth?.value}%;
         flex-direction:${item?.layoutSettings?.flexDirection};
         flex-wrap:${item?.layoutSettings?.flexWrap};
          
          justify-content:${item?.layoutSettings?.justifyContent};
         align-items:${item?.layoutSettings?.alignItems};
          gap:  ${item?.layoutSettings?.gap}px;
         background:${item?.layoutSettings?.layoutBG?.color};
         
         border-radius:${item?.layoutSettings?.borderRadius1?.value}${item?.layoutSettings?.borderRadius1?.resolution};
         box-shadow:${item?.layoutSettings?.layoutShadow?.horizontal?.value}px ${item?.layoutSettings?.layoutShadow?.vertical?.value}px ${item?.layoutSettings?.layoutShadow?.blur?.value}px ${item?.layoutSettings?.layoutShadow?.spread?.value}px ${item?.layoutSettings?.layoutShadow?.shadowColor?.color} ${item?.layoutSettings?.layoutShadow?.inset?"inset":""};

     
          padding-top: 12px; padding-bottom: 12px;
        }
          

          .PlatformKeyFeaturesCard1-card-${item?.myKey}:hover {
         
         
         
        }
          .PlatformKeyFeaturesCard1-cardLeft-${item?.myKey} {
          display:flex;margin:10px;
          
       border-radius:${item?.layoutSettings?.borderRadius1?.value}${item?.layoutSettings?.borderRadius1?.resolution};
           width:${item?.layoutSettings?.layoutWidth?.value}%;
           background: ${item?.layoutSettings?.layoutBG?.color};
 margin-top:${item?.layoutSettings?.margin?.marginTop?.value}${item?.layoutSettings?.margin?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.margin?.marginBottom?.value}${item?.layoutSettings?.margin?.marginBottom?.resolution};
            margin-left:${item?.layoutSettings?.margin?.marginLeft?.value}${item?.layoutSettings?.margin?.marginLeft?.resolution};
            margin-right:${item?.layoutSettings?.margin?.marginRight?.value}${item?.layoutSettings?.margin?.marginRight?.resolution};
          
        }
 
.PlatformKeyFeaturesCard1-cardRight-${item?.myKey} {
           display:flex;position:relative;
           flex-wrap:${item?.layoutSettings?.flexWrap}; 
           flex-direction:${item?.layoutSettings?.flexDirection};
           width:${item?.layoutSettings?.layoutWidth?.value}%;
          
          gap: ${item?.layoutSettings?.gap}px;
           background: ${item?.layoutSettings?.layoutBG?.color};
          border-radius:${item?.layoutSettings?.borderRadius1?.value}${item?.layoutSettings?.borderRadius1?.resolution};
         
          padding:10px;
           margin-top:${item?.layoutSettings?.margin?.marginTop?.value}${item?.layoutSettings?.margin?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.margin?.marginBottom?.value}${item?.layoutSettings?.margin?.marginBottom?.resolution};
            margin-left:${item?.layoutSettings?.margin?.marginLeft?.value}${item?.layoutSettings?.margin?.marginLeft?.resolution};
            margin-right:${item?.layoutSettings?.margin?.marginRight?.value}${item?.layoutSettings?.margin?.marginRight?.resolution};
           padding-top:${item?.layoutSettings?.padding?.paddingTop?.value}${item?.layoutSettings?.padding?.paddingTop?.resolution};
            padding-bottom:${item?.layoutSettings?.padding?.paddingBottom?.value}${item?.layoutSettings?.padding?.paddingBottom?.resolution};
            padding-left:${item?.layoutSettings?.padding?.paddingLeft?.value}${item?.layoutSettings?.padding?.paddingLeft?.resolution};
            padding-right:${item?.layoutSettings?.padding?.paddingRight?.value}${item?.layoutSettings?.padding?.paddingRight?.resolution};
            border:${item?.layoutSettings?.layoutBorder?.borderWidth?.value}px ${item?.layoutSettings?.layoutBorder?.borderType} ${item?.layoutSettings?.layoutBorder?.borderColor?.color};
          
        }
      .icon-wrapper {
          color: #4f46e5;
          flex-shrink: 0;
        }

        .PlatformKeyFeaturesCard1-cardLeft-text-wrapper${item?.myKey} {
          flex-grow: 1;  display:flex;
          flex-direction:column;
           position:relative;z-index:99999;
      
            padding:10px;
          border-radius: 12px;
          
          margin-bottom: 12px;
          
        } 
          .PlatformKeyFeaturesCard1-cardRight-text-wrapper${item?.myKey} {
          position:relative;z-index:99999;
          margin-top:${item?.layoutSettings?.marginItem2?.marginTop?.value}${item?.layoutSettings?.marginItem2?.marginTop?.resolution};
         
             margin-left:${item?.layoutSettings?.marginItem2?.marginLeft?.value}${item?.layoutSettings?.marginItem2?.marginLeft?.resolution};
            margin-bottom:${item?.layoutSettings?.marginItem2?.marginBottom?.value}${item?.layoutSettings?.marginItem2?.marginBottom?.resolution};
          padding-top:${item?.layoutSettings?.paddingItem2?.paddingTop?.value}${item?.layoutSettings?.marginItem2?.marginTop?.resolution};
         
              padding-bottom:${item?.layoutSettings?.paddingItem2?.paddingBottom?.value}${item?.layoutSettings?.paddingItem2?.paddingBottom?.resolution};
         
        } 
          .PlatformKeyFeaturesCard1-cardRight-item-wrapper${item?.myKey} {
          flex-grow: 1;   width:40%;
        position:relative;
         
          
        } .PlatformKeyFeaturesCard1-cardRight-item-wrapperInner${item?.myKey} {
          flex-grow: 1;   position:relative; 
        box-shadow:${item?.layoutSettings?.layoutShadow?.horizontal?.value}px ${item?.layoutSettings?.layoutShadow?.vertical?.value}px ${item?.layoutSettings?.layoutShadow?.blur?.value}px ${item?.layoutSettings?.layoutShadow?.spread?.value}px ${item?.layoutSettings?.layoutShadow?.shadowColor?.color} ${item?.layoutSettings?.layoutShadow?.inset?"inset":""};

     
             background: ${item?.layoutSettings?.item1BG?.color};
             overflow:hidden ;
            padding: 16px;
            border-radius:${item?.layoutSettings?.borderRadius1?.value}${item?.layoutSettings?.borderRadius1?.resolution};
      
         
         
          
        }
.PlatformKeyFeaturesCard1-CardSVGBG-wrapper${item?.myKey} {
position:absolute;
width:50px;height:50px;
margin-top:-50px;
       box-shadow:${item?.layoutSettings?.item2Shadow?.horizontal?.value}px ${item?.layoutSettings?.item2Shadow?.vertical?.value}px ${item?.layoutSettings?.item2Shadow?.blur?.value}px ${item?.layoutSettings?.item2Shadow?.spread?.value}px ${item?.layoutSettings?.item2Shadow?.shadowColor?.color} ${item?.layoutSettings?.item2Shadow?.inset?"inset":""};
 
}
  
.PlatformKeyFeaturesCard1-CardImage-wrapper${item?.myKey} {

position:absolute;z-index:99999;
width:95px;height:95px;
   
}
  
          .PlatformKeyFeaturesCard1-cardBottom${item?.myKey} {
          flex-grow: 1;   width:100%;
        display:flex; flex-wrap:wrap; align-items:center;
           flex-wrap:wrap;gap:10px;
             
          
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          padding-top: 12px; padding-bottom: 12px;
          
        }
          .PlatformKeyFeaturesCard1-cardBottom-item-wrapper${item?.myKey} {
          flex-grow: 1;   width:25%;
        position:relative;
             background: #fff;overflow:hidden;
          padding: 16px;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          margin: 12px;
          
        }
          .PlatformKeyFeaturesCard1-title-${item?.myKey} {
          font-family:${fonts[2]?.fontFamily} !important;
        font-size: 2.1rem;
        background:${item?.layoutSettings?.item1BG?.color};
        margin-top:${item?.layoutSettings?.marginItem1?.marginTop?.value}${item?.layoutSettings?.marginItem1?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.marginItem1?.marginBottom?.value}${item?.layoutSettings?.marginItem1?.marginBottom?.resolution};
            margin-left:${item?.layoutSettings?.marginItem1?.marginLeft?.value}${item?.layoutSettings?.marginItem1?.marginLeft?.resolution};
            margin-right:${item?.layoutSettings?.marginItem1?.marginRight?.value}${item?.layoutSettings?.marginItem1?.marginRight?.resolution};
  
border-radius:${item?.layoutSettings?.borderRadius2?.value}${item?.layoutSettings?.borderRadius2?.resolution};
         color: #222;
        }

        .PlatformKeyFeaturesCard1-description-${item?.myKey} {
         font-family:${fonts[2]?.fontFamily} !important;
         background:${item?.layoutSettings?.item2BG?.color};
         
border-radius:${item?.layoutSettings?.borderRadius3?.value}${item?.layoutSettings?.borderRadius3?.resolution};
          font-size: 1rem;position:relative;z-index:999;
          color: #555;
        
        }
.PlatformKeyFeaturesCard1-cardRight-title-${item?.myKey} {
         position:relative;z-index:999;
        background: ${item?.layoutSettings?.typographyTitle?.titleColor?.color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-clip: text;
  color: transparent;
          width:${item?.layoutSettings.item2Width?.value?item?.layoutSettings.item2Width?.value:70}%;
          
     white-space: ${item?.layoutSettings.titleEllipsis?.status?"nowrap":"none"};
    overflow:  ${item?.layoutSettings.titleEllipsis?.status?"hidden":"none"};
    text-overflow: ${item?.layoutSettings.titleEllipsis?.status?"ellipsis":"none"} ;;

   
        }

        .PlatformKeyFeaturesCard1-cardRight-description-${item?.myKey} {
          font-size: 0.85rem;position:relative;z-index:999;
           background: ${item?.layoutSettings?.typographySubtitle?.titleColor?.color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-clip: text;
  color: transparent;
          width:${item?.layoutSettings.item2Width?.value?item?.layoutSettings.item2Width?.value:70}%;
          
     white-space: ${item?.layoutSettings.subtitleEllipsis?.status?"nowrap":"none"};
    overflow:  ${item?.layoutSettings.subtitleEllipsis?.status?"hidden":"none"};
    text-overflow: ${item?.layoutSettings.subtitleEllipsis?.status?"ellipsis":"none"} ;;
   }
           .PlatformKeyFeaturesCard1-cardRight-description-ellipsis-${item?.myKey} {
         white-space: nowrap;
    overflow:  hidden;
    text-overflow: ellipsis
      } .PlatformKeyFeaturesCard1-cardRight-title-ellipsis-${item?.myKey} {
        
           white-space: nowrap;
    overflow:  hidden;
    text-overflow: ellipsis
      }

/* sm */
@media (min-width: 768px) and (max-width: 991px) {
.PlatformKeyFeaturesCard1-card-${item?.myKey} { flex-direction:column;}
  .PlatformKeyFeaturesCard1-cardLeft-${item?.myKey} { width:95%;}
 .PlatformKeyFeaturesCard1-cardRight-${item?.myKey} {width:95%;margin-bottom:0px;margin-left:0px; margin-right:0px; border-radius:0px;;}
  
  
  }
                                   /* xs */
@media (max-width: 767px) {
 .PlatformKeyFeaturesCard1-card-${item?.myKey} { flex-direction:column;}
  .PlatformKeyFeaturesCard1-cardLeft-${item?.myKey} { width:95%;}
  .PlatformKeyFeaturesCard1-cardRight-${item?.myKey} {width:90%;margin-bottom:0px;margin-left:0px; margin-right:0px; border-radius:0px;;}
  .PlatformKeyFeaturesCard1-cardRight-item-wrapper${item?.myKey} {   width:50%;
      }
    .PlatformKeyFeaturesCard1-cardBottom-item-wrapper${item?.myKey} {width:95%;}
    .PlatformKeyFeaturesCard1-cardRight-text-wrapper${item?.myKey}{margin-left:10px;}
    .PlatformKeyFeaturesCard1-CardImage-wrapper${item?.myKey} { }
    .PlatformKeyFeaturesCard1-cardRight-title-${item?.myKey} { width:100%;top:32px}
  .PlatformKeyFeaturesCard1-cardRight-description-${item?.myKey} { font-size: 0.7rem;width:100%;top:8px}
  .PlatformKeyFeaturesCard1-cardRight-title-${item?.myKey} {font-size: 1.1rem;}
}
 
      `))}</style>
  
</>)
}
export default PlatformKeyFeaturesCard1;